import { Component } from '@angular/core';
import {Router, ActivatedRoute, Event as RouterEvent, NavigationStart, NavigationEnd, NavigationCancel, NavigationError, RoutesRecognized} from '@angular/router';
import { SpinnerService } from './shared/spinner/spinner.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  isMenuVisible: boolean;
  isAlertMsgVisible: boolean;

  constructor(public router: Router, private route: ActivatedRoute, private spinnerService: SpinnerService) {
    router.events.subscribe((event: RouterEvent) => {
      this.navigationInterceptor(event);
      this.displayAlerMsg(event);
    });

    this.isMenuVisible = false;
    this.isAlertMsgVisible = true;
  }

  public toggleMenu(): void {
    this.isMenuVisible = !this.isMenuVisible;
  }

  public displayAlerMsg(event: RouterEvent){
    if (event instanceof RoutesRecognized) {
      let urlSplit = event.urlAfterRedirects.trim().split("/");
      if(urlSplit[1] == "cancellation" || urlSplit[1] == "order" || urlSplit[1] == "customer-infos-order") {
        this.isAlertMsgVisible = false;
      } else {
        this.isAlertMsgVisible = true;
      }
    }
  }

  public getUser(): any {
    return localStorage.getItem('user');
  }

  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.spinnerService.start("");
    }
    if (event instanceof NavigationEnd) {
      this.spinnerService.stop();
    }
    if (event instanceof NavigationCancel || event instanceof NavigationError) {
      this.spinnerService.stop();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts